// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1346":"f85148cd","5367":"6726f050","9172":"f85148cd"}[chunkId] + ".chunk.css";
};